/* Mengenauswahl in der Produktkachel.
 *
 * Jede Option traegt ihren fertigen Stueckpreis als `data-preis` -- in
 * Liquid mit dem `money`-Filter gesetzt. Hier wird er nur umkopiert: kein
 * Formatieren von Geld in JavaScript, damit Waehrung, Trennzeichen und
 * Rundung an einer Stelle bleiben.
 *
 * Vor der ersten Auswahl steht "ab 4,72 EUR" in der Kachel. Sobald jemand
 * eine Stufe waehlt, steht dort der Stueckpreis dieser Stufe -- "ab" waere
 * dann falsch, die Menge ist ja bestimmt.
 *
 * Delegiert auf dem Dokument: das Raster wird beim Filtern und Blaettern
 * ueber die Section Rendering API neu gezeichnet, einzeln gebundene
 * Listener waeren danach weg.
 */
(function () {
  function preisSetzen(feld) {
    var kachel = feld.closest('.hs-kachel');
    if (!kachel) return;
    var anzeige = kachel.querySelector('[data-hs-kachelpreis]');
    var option = feld.options[feld.selectedIndex];
    if (!anzeige || !option || !option.dataset.preis) return;
    anzeige.textContent = option.dataset.preis;
  }

  document.addEventListener('change', function (e) {
    var feld = e.target.closest('[data-hs-kachelmenge]');
    if (feld) preisSetzen(feld);
  });

  // Glitch 22.10.2026 (Lukas): nach „Zurueck" stellt der Browser die zuletzt
  // gewaehlte Menge wieder her (z. B. „1 Dose"), ohne `change` -- daneben
  // stand weiter „ab €3,92". Weicht die Auswahl von der Vorauswahl ab, gilt
  // der Preis dieser Auswahl.
  function abgleichen() {
    document.querySelectorAll('[data-hs-kachelmenge]').forEach(function (feld) {
      var option = feld.options[feld.selectedIndex];
      if (option && !option.defaultSelected) preisSetzen(feld);
    });
  }
  window.addEventListener('pageshow', abgleichen);
  if (document.readyState !== 'loading') abgleichen();
})();
